<template>
    <v-card>
        <!-----------------------------------------PROJECT MENU----------------------------------------->
        <v-row no-gutters>
            <v-col cols="2">
                <v-btn
                    variant="elevated"
                    color="blue"
                    size="x-large"
                    class="returnBtn"
                    @click="$emit('hideActivityMenu')"
                >
                    Return to Home
                </v-btn>
            </v-col>
            <v-col cols="10">
                <v-row class="title">
                    <v-col cols="12"> Projects </v-col>
                </v-row>

                <v-row style="flex: none">
                    <v-col cols="4" />
                    <v-col cols="4">
                        <v-text-field
                            v-model="projectNumberSearch"
                            label="Search by Number"
                            append-inner-icon="mdi:mdi-magnify"
                            variant="outlined"
                            hide-details
                            clearable
                            @click:clear="onClearClicked_SearchProjectNum()"
                        />
                    </v-col>
                    <v-col cols="4" />
                </v-row>

                <v-row class="grid gridList">
                    <v-col
                        cols="3"
                        v-for="(item, index) in filteredProjects"
                        :key="index"
                        class="grid pa-0"
                    >
                        <v-btn
                            variant="flat"
                            @click="selectProject(item)"
                            class="project pa-6"
                            :class="{ selected: item === this.selectedProject }"
                        >
                            {{ item.Number }} <br />
                            {{ item.ProjectName }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>

    <v-dialog
        v-model="fixtureMenu"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
    >
        <!-----------------------------------------FIXTURE MENU----------------------------------------->
        <v-card>
            <v-row no-gutters>
                <v-col cols="2">
                    <v-btn
                        variant="elevated"
                        color="blue"
                        size="x-large"
                        class="returnBtn"
                        @click="fixtureMenu = false"
                    >
                        Return to Projects
                    </v-btn>
                </v-col>
                <v-col cols="10">
                    <v-row class="title">
                        <v-col cols="12"> Fixtures </v-col>
                    </v-row>

                    <v-row style="flex: none">
                        <v-col cols="1" />
                        <v-col cols="4">
                            <v-text-field
                                v-model="fixtureNumberSearch"
                                label="Search by Fixture Number"
                                append-inner-icon="mdi:mdi-magnify"
                                variant="outlined"
                                hide-details
                                clearable
                                @click:clear="onClearClicked_SearchFixtureNum()"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="2" />
                        <v-col cols="4">
                            <v-text-field
                                v-model="fixtureNameSearch"
                                label="Search by Fixture Name"
                                append-inner-icon="mdi:mdi-magnify"
                                variant="outlined"
                                hide-details
                                clearable
                                @click:clear="
                                    onClearClicked_SearchFixtureName()
                                "
                            />
                        </v-col>
                        <v-col cols="1" />
                    </v-row>

                    <v-row class="grid gridList">
                        <v-col
                            cols="3"
                            v-for="(item, index) in filteredFixtures"
                            :key="index"
                            class="grid pa-0"
                        >
                            <v-btn
                                variant="flat"
                                @click="selectFixture(item)"
                                class="project pa-6"
                                :class="{
                                    selected: item === this.selectedFixture,
                                }"
                            >
                                {{ item.FixtureNumber }} <br />
                                {{ item.FixtureName }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog
            v-model="processesMenu"
            fullscreen
            :scrim="false"
            transition="dialog-bottom-transition"
        >
            <!-----------------------------------------PROCESSES MENU----------------------------------------->
            <v-card>
                <v-row no-gutters class="text-center">
                    <v-col cols="2">
                        <v-btn
                            variant="elevated"
                            color="blue"
                            size="x-large"
                            class="returnBtn"
                            @click="processesMenu = false"
                        >
                            Return to Fixtures
                        </v-btn>
                    </v-col>
                    <v-col cols="10">
                        <v-row class="title mb-2">
                            <v-col cols="12"> Processes </v-col>
                        </v-row>

                        <v-row class="grid gridList">
                            <v-col
                                cols="3"
                                v-for="(item, index) in processes"
                                :key="index"
                                class="grid pa-0"
                            >
                                <v-btn
                                    variant="flat"
                                    @click="selectProcess(item)"
                                    class="project pa-6"
                                    :class="{
                                        selected: item === this.selectedProcess,
                                    }"
                                >
                                    {{ item.ProcessName }}
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-btn
                            variant="elevated"
                            color="green"
                            size="x-large"
                            class="startBtn"
                            :loading="startLoad"
                            @click="startActivity()"
                        >
                            Start Activity
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-snackbar
                v-model="snackbar.show"
                :text="snackbar.msg"
                :color="snackbar.color"
                timeout="3000"
            />
        </v-dialog>
    </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    name: "DPAM_Start_Activity",
    components: {},
    emits: ["hideActivityMenu"],
    data() {
        return {
            loading: false,
            startLoad: false,
            projectNumberSearch: "",
            projects: [],
            selectedProject: null,
            fixtureMenu: false,
            fixtureNumberSearch: "",
            fixtureNameSearch: "",
            fixtures: [],
            selectedFixture: null,
            processesMenu: false,
            processes: [],
            selectedProcess: null,
            snackbar: {
                show: false,
                msg: "",
                color: "error",
            },
        };
    },
    async mounted() {
        this.getProjects();
        this.getProcesses();
    },
    computed: {
        filteredProjects() {
            return this.projects.filter((project) =>
                project.Number.toLowerCase().includes(
                    this.projectNumberSearch.toLowerCase()
                )
            );
        },
        filteredFixtures() {
            return this.fixtures.filter(
                (fixture) =>
                    fixture.FixtureNumber.toLowerCase().includes(
                        this.fixtureNumberSearch.toLowerCase()
                    ) &&
                    fixture.FixtureName.toLowerCase().includes(
                        this.fixtureNameSearch.toLowerCase()
                    )
            );
        },
    },
    methods: {
        async getProjects() {
            try {
                // this.loading = true;
                await axios
                    .get(route("api.getAllActiveProject"))
                    .then((response) => {
                        this.projects = response.data.data;
                        // this.loading = false;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getFixtures() {
            try {
                // this.loading = true;
                await axios
                    .get(
                        route("api.getAllActiveProjectFixturesByID", {
                            ID: this.selectedProject.ID,
                        })
                    )
                    .then((response) => {
                        this.fixtures = response.data.data;
                        // this.loading = false;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getProcesses() {
            try {
                await axios
                    .get(route("api.getAllProcesses"))
                    .then((response) => {
                        this.processes = response.data.data;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async startActivity() {
            this.startLoad = true;
            if (!this.selectedFixture || !this.selectedProcess) {
                this.snackbar = {
                    show: true,
                    msg: "ERROR: Please make sure you have selected a PROJECT, FIXTURE and PROCESS",
                    color: "error",
                };
                this.startLoad = false;
                return;
            }
            try {
                await axios
                    .post(
                        route("api.inputActivities", {
                            UserID: 1,
                            FixtureID: this.selectedFixture.ID,
                            ProcessID: this.selectedProcess.ID,
                        })
                    )
                    .then((response) => {
                        if (response.data === true) {
                            this.snackbar = {
                                show: true,
                                msg: "Starting activity. Please Wait.",
                                color: "success",
                            };
                            setTimeout(() => {
                                try {
                                    axios
                                        .post(route("api.punch-system-logout"))
                                        .then((response) => {
                                            window.location.href =
                                                route("log-in-punch");
                                        });
                                } catch (err) {
                                    console.log(err);
                                }
                            }, 2000);
                        } else {
                            this.snackbar = {
                                show: true,
                                msg: "ERROR: Please make sure you have selected a PROJECT, FIXTURE and PROCESS",
                                color: "error",
                            };
                            this.startLoad = false;
                        }
                    });
            } catch (err) {
                console.log(err);
            }
        },
        selectProject(item) {
            this.selectedProject = item;
            this.getFixtures();
            this.fixtureMenu = true;
        },
        selectFixture(item) {
            this.selectedFixture = item;
            this.processesMenu = true;
        },
        selectProcess(item) {
            this.selectedProcess = item;
        },
        onClearClicked_SearchProjectNum() {
            this.projectNumberSearch = "";
        },
        onClearClicked_SearchFixtureNum() {
            this.fixtureNumberSearch = "";
        },
        onClearClicked_SearchFixtureName() {
            this.fixtureNameSearch = "";
        },
    },
};
</script>

<style scoped>
.title {
    text-align: center;
    letter-spacing: 0.12em;
    color: #fff;
    background-color: #0cb08b;
    font-size: 250%;
    flex: none;
}
.grid {
    border: 1px solid lightgray;
}
.gridList {
    max-height: 75vh;
    overflow-y: auto;
    margin: 8px;
    text-align: center;
}
.project {
    height: 25vh;
    width: 100%;
    border-radius: 0;
}
.project:hover {
    background-color: #2196f3;
    color: white;
}
:deep(.v-btn__content) {
    font-size: 1.5em;
    text-transform: none;
    text-wrap: wrap;
}
.selected {
    background-color: #2196f3;
    color: white;
    cursor: pointer;
}
.returnBtn {
    height: 100%;
    width: 100%;
}
.startBtn {
    height: 10vh;
    margin: 8px;
    width: 95%;
}
:deep(.v-snackbar__content) {
    font-size: 1.25em;
    text-align: center;
}
</style>
